import healthImg from './assets/001-cross.png'
import suppliesImg from './assets/002-wooden-crate.png'
import fameImg from './assets/003-star.png'
import brainImg from './assets/004-brain.png'
import { RESOURCE } from '../game/constants'

export default new Map([
    [ RESOURCE.HEALTH, { src: healthImg, alt: 'Health'} ],
    [ RESOURCE.SANITY, { src: brainImg, alt: 'Sanity' } ],
    [ RESOURCE.SUPPLIES, { src: suppliesImg, alt: 'Supplies' } ],
    [ RESOURCE.FAME, { src: fameImg, alt: 'Fame' } ]
])